<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Template Surat</section>
    <!-- Body -->
    <div class="w-full p-5">
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Nama Template Surat"
              v-model="nama"
              name="nama"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('nama')">{{
              errors.first("nama")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <v-select :options="listKategoriSurat" v-model="selectedKategoriSurat" name="kategori" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('kategori')">{{
              errors.first("kategori")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Keterangan"
              v-model="keterangan"
              name="keterangan"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('keterangan')">{{
              errors.first("keterangan")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <vs-upload @change="handleOnFileChange" ref="upload" placeholder="Upload File Surat" :singleUpload="1" :limit="1"/>
        </div>
      </form>
    </div>

    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Update Template 
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import { digofHttp as axios } from "@/axios";
import vSelect from "vue-select";
import {GET_ALL as ALL_KATEGORI} from '@/query/kategori-surat';

export default {
  components : {
    'v-select': vSelect
  },
  props : {
    templateSurat : {
      type : Object,
      required : true
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      keterangan : '',
      nama : '',
      selectedKategoriSurat : {value : '', label : 'Pilih kategori surat'},
      formValues: {
        files: [],
        removeIds: []
      }
    };
  },
  apollo : {
    listKategoriSurat : {
      query : ALL_KATEGORI,
      update : (data) => {
        let list = [];
        data.kategoriSurat.data.map(item => {
          list.push({value : item.id, label : item.nama})
        });
        return list;
      },
      variables(){
        return {
          perPage : 300
        }
      },
      fetchPolicy: "cache-and-network",
    }
  },
  watch: {
    templateSurat: function() {
      this.assignData();
    }
  },
  methods: {
    assignData(){
      this.nama = this.templateSurat.nama;
      this.keterangan = this.templateSurat.keterangan;
      this.selectedKategoriSurat = {value : this.templateSurat.kategori_surat.id, label : this.templateSurat.kategori_surat.nama}
    },

    async handleOnSubmit() {
      try {
        await this.updateTemplateSurat();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Gagal",
          text: "Oops terjadi kesalahan, silahkan hubungi tim IT.",
          color: "danger"
        });
      }
    },

    handleOnCancel() {
      this.toggleActive(false);
    },

    handleOnFileChange() {
      const files = this.$refs.upload.filesx;
      if (!files.length) return;
      this.formValues.files = files;
    },

    submitCallback() {
      this.$emit("submitCallback", true);
    },

    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },

    async updateTemplateSurat() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          axios({
            url: "template-surat/update",
            method: "post",
            headers: {
              "Content-Type": "multipart/form-data"
            },
            data: this.getFormDataPayload()
          }).then(() => {
            this.$vs.notify({
              title: "Sukses",
              text: "Berhasil memperbaharui template surat.",
              color: "success"
            });
            this.submitCallback();
            this.toggleActive(false);
          })
          .catch(e => {
            console.error(e);
            this.$vs.notify({
              title: "Gagal",
              text: "Terjadi kesalahan, silahkan hubungi tim IT!",
              color: "danger",
              position: "top-right"
            });
          });
        }
        else{
          this.$vs.notify({
            title: "Silahkan lengkapi formulir terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },

    getFormDataPayload() {
      const formData = new FormData();
      formData.append("pengguna_id", this.$sanctum.getUser().id);
      formData.append("keterangan", this.keterangan);
      formData.append("nama", this.nama);
      formData.append("template_surat_id", this.templateSurat.id);
      formData.append("kategori_surat_id", this.selectedKategoriSurat.value);
      this.formValues.files.forEach(file => {
        return formData.append("files", file);
      });
      return formData;
    },
  }
};
</script>
